// extracted by mini-css-extract-plugin
export var blue = "sectionNumberedVerticalCards-module--blue--6d60c";
export var card = "sectionNumberedVerticalCards-module--card--86ed0";
export var cards = "sectionNumberedVerticalCards-module--cards--bb71c";
export var image = "sectionNumberedVerticalCards-module--image--333bd";
export var number = "sectionNumberedVerticalCards-module--number--0842c";
export var section = "sectionNumberedVerticalCards-module--section--2cdaf";
export var text = "sectionNumberedVerticalCards-module--text--15a52";
export var titleAndNumber = "sectionNumberedVerticalCards-module--titleAndNumber--9e288";